<div class="w-100">
  <div class="page-info">
    <h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Day Book</h3>
  </div>
  <div class="page-next"><mat-icon mat-list-icon style="padding: 1px;"
      routerLink="/tallyentry">arrow_circle_right</mat-icon></div>
</div>

<div class="border-p table-container">
  <!-- Financial Year -->
  <mat-form-field class="w-30 pl-20" appearance="outline">
    <mat-label class="custom-mat-label">Financial Year</mat-label>
    <mat-select matNativeControl required [(ngModel)]="l_formDataDaybook.finyearmstId">
      <mat-select-trigger>
        {{ lFN_GetFinancialYearText(l_formDataDaybook.finyearmstId) }}
      </mat-select-trigger>
      <mat-option *ngFor="let l_financialyear of l_financialYearList" [value]="l_financialyear.finyearmstId">
        <div class="option-container">
          <span>{{ l_financialyear.finyear }}</span>
          <ng-container *ngIf="l_financialyear.status">
            <mat-icon class="active-icon">check_circle</mat-icon>
          </ng-container>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- Category name -->
  <mat-form-field class="w-20 pl-10" appearance="outline">
    <mat-label class="custom-mat-label">Txncategory</mat-label>
    <mat-select multiple [(ngModel)]="l_formDataDaybook.txnCategories" (selectionChange)="lFN_FetchDayBookList();">
      <mat-option *ngFor="let l_category of l_categoryList" [value]="l_category.txncategoryId">
        {{ l_category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- Fetch All -->
  <button mat-raised-button color="primary" class="custom-button-blue ml-15" (click)="lFN_FetchAllDatalist();">
    View All
  </button>
</div>
<div class="border-p table-container">
  <!-- ReceiptNo Search -->
  <mat-form-field class="w-10 pl-10" appearance="outline">
    <mat-label class="custom-mat-label">Receipt Number</mat-label>
    <input matInput placeholder="Receipt number" [(ngModel)]="l_formDataDaybook.receiptNo"
      (ngModelChange)="lFN_FilterDaybookDetails();">
  </mat-form-field>
  <!-- Book Number -->
  <mat-form-field class="w-10 pl-20" appearance="outline">
    <mat-label class="custom-mat-label">Book Number</mat-label>
    <input matInput type="number" placeholder="Enter Book No" [(ngModel)]="l_formDataDaybook.bookNo"
      (ngModelChange)="lFN_FilterDaybookDetails();">
  </mat-form-field>
  <!-- Search by Date -->
  <mat-form-field class="w-10 pl-10" appearance="outline">
    <mat-label class="custom-mat-label">Receipt Date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="l_formDataDaybook.txndate" [min]="minDatePicker"
      [max]="maxDatePicker" (ngModelChange)="lFN_FilterDaybookDetails();" (dateChange)="lFN_FilterDaybookDetails();">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <!-- Narration Search -->
  <mat-form-field class="w-20 pl-10" appearance="outline">
    <mat-label class="custom-mat-label">Narration</mat-label>
    <input matInput placeholder="Search by narration" [(ngModel)]="l_formDataDaybook.narration"
      (ngModelChange)="lFN_FilterDaybookDetails();">
  </mat-form-field>
  <!-- Purpose Search -->
  <mat-form-field class="w-10 pl-10" appearance="outline">
    <mat-label class="custom-mat-label">Purpose</mat-label>
    <input matInput placeholder="Search by purpose" [(ngModel)]="l_formDataDaybook.purpose"
      (ngModelChange)="lFN_FilterDaybookDetails();">
  </mat-form-field>
  <!-- Amount Search -->
  <mat-form-field class="w-10 pl-10" appearance="outline">
    <mat-label class="custom-mat-label">Amount</mat-label>
    <input matInput type="number" placeholder="Search by amount" [(ngModel)]="l_formDataDaybook.amount"
      (ngModelChange)="lFN_FilterDaybookDetails();">
  </mat-form-field>
</div>

<mat-chip-list class="justify-content">
  <mat-chip [ngClass]="{'active-receipts': true}" style="margin-left: 25px; margin-bottom: 20px;">
    <mat-label style="color: aliceblue;">Receipt count: {{ l_receiptCount }}</mat-label>
  </mat-chip>
  <!-- <mat-chip [ngClass]="{'active-receipts': true}" style="margin-left: 25px; margin-bottom: 20px;">
    <mat-label style="color: aliceblue;">Total Amount: {{ l_totalAmount }}</mat-label>
  </mat-chip> -->
</mat-chip-list>

<div class="mat-elevation-z8 table-container" style="margin-left: 20px; margin-right: 20px;">
  <table mat-table [dataSource]="dataSource" class="mat-table">
    <!-- Txn Date Column -->
    <ng-container matColumnDef="txndate">
      <th mat-header-cell *matHeaderCellDef>Txndate</th>
      <td mat-cell *matCellDef="let element">{{element.txndate}}</td>
    </ng-container>

    <!-- Book No. Column -->
    <ng-container matColumnDef="bookNo">
      <th mat-header-cell *matHeaderCellDef>Book</th>
      <td mat-cell *matCellDef="let element">{{element.bookNo}}</td>
    </ng-container>

    <!-- Receipt No. Column -->
    <ng-container matColumnDef="receiptNo">
      <th mat-header-cell *matHeaderCellDef>Receipt No</th>
      <td mat-cell *matCellDef="let element">{{element.receiptNo}}</td>
    </ng-container>

    <!-- Narration Column -->
    <ng-container matColumnDef="narration">
      <th mat-header-cell *matHeaderCellDef>Narration</th>
      <td mat-cell *matCellDef="let element">{{element.narration}}</td>
    </ng-container>

    <!-- Purpose Column -->
    <ng-container matColumnDef="purpose">
      <th mat-header-cell *matHeaderCellDef>Purpose</th>
      <td mat-cell *matCellDef="let element">{{element.purpose}}</td>
    </ng-container>

    <!-- Amount Column -->
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>Amount</th>
      <td mat-cell *matCellDef="let element">{{element.amount}}</td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>&nbsp;&nbsp;&nbsp;Actions</th>
      <td mat-cell *matCellDef="let element" class="actions-cell">
        <button mat-icon-button (click)="lFN_EditReceipt(element);">
          <mat-icon title="Edit Receipt" style="-webkit-text-fill-color: #2a457a">edit</mat-icon>
        </button>
        <button mat-icon-button (click)="lFN_ViewReceipt(element);">
          <mat-icon title="View Details" style="-webkit-text-fill-color: #2a457a">visibility</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Status -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element" class="actions-cell">
        <button mat-icon-button (click)="l_ChangeStatus(element)">
          <mat-chip class="status-chip" [ngClass]="{
              'active-status': element.status,
              'inactive-status': !element.status
            }">
            <mat-label>{{ element.status ? 'Active' : 'Inactive' }}</mat-label>
          </mat-chip>
        </button>
      </td>
    </ng-container>

    <!-- Mappings -->
    <ng-container matColumnDef="mapping">
      <th mat-header-cell *matHeaderCellDef>Mapping</th>
      <td mat-cell *matCellDef="let element" class="actions-cell">
        <button mat-icon-button *ngIf="element.mapexternal">
          <mat-icon title="Mapping required for this receipt" class="posting-icon">exit_to_app</mat-icon>
        </button>
        <button mat-icon-button *ngIf="(element.mapexternal == false)">
          <mat-icon title="Mapping completed" class="bold-icon">done_outline</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="receiptLocked">
      <th mat-header-cell *matHeaderCellDef>Lock Info</th>
      <td mat-cell *matCellDef="let element" class="actions-cell">
        <button mat-icon-button *ngIf="element.receiptLocked">
          <mat-icon title="Locked Receipt" class="posting-icon">lock</mat-icon>
        </button>
        <button mat-icon-button *ngIf="(element.receiptLocked == false)">
          <mat-icon title="Editable Receipt" class="bold-icon">lock_open</mat-icon>
        </button>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>